import { useEffect, useMemo, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./categoryContent.gql";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const useCategoryContent = ({
  categoryId,
  data,
  pageSize = 6,
  filters,
}) => {
  const { ConfigData } = useSelector((state) => state.homePageSlice);
  const location = useLocation();
  const [filterModal, setFilterModal] = useState(false);
  const [filterTileSidebar, setFilterTileSidebar] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [categoryNames, setCategoryNames] = useState([]);

  const { getProductFiltersByCategoryQuery, getCategoryContentQuery } =
    DEFAULT_OPERATIONS;
  const placeholderItems = useMemo(
    () => Array.from({ length: pageSize }).fill(null),
    [pageSize]
  );

  const [getFilters, { data: filterData }] = useLazyQuery(
    getProductFiltersByCategoryQuery,
    {
      fetchPolicy: "cache-and-network",
      nextFetchPolicy: "cache-first",
      context: { fetchOptions: { method: "GET" } },
    }
  );

  useEffect(() => {
    setSelectedFilters([]);
  }, [location.pathname]);

  const { data: categoryData } = useQuery(getCategoryContentQuery, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    skip: !categoryId,
    variables: {
      id: categoryId,
    },
    context: { fetchOptions: { method: "GET" } },
  });

  useEffect(() => {
    if (filters) {
      const { name, ...filtersWithoutName } = filters;
      getFilters({
        variables: { filters: filtersWithoutName },
      });
    }
  }, [filters, getFilters]);

  const filtersListing = useMemo(() => {
    if (!filterData) return null;

    return filterData?.products?.aggregations
      .map((item) => ({
        ...item,
        options: item.options.filter(
          (op) =>
            op.label.toLowerCase() !== "na" && op.label.toLowerCase() !== "n/a"
        ),
      }))
      .filter((item) => item.options.length > 0);
  }, [filterData]);

  const items = data ? data.products.items : placeholderItems;
  const totalPagesFromData = data?.products?.page_info?.total_pages ?? null;
  const totalCount = data?.products?.total_count ?? null;
  const categoryImage = categoryData
    ? categoryData.category && categoryData.category
    : null;

  return {
    filtersListing,
    items,
    totalCount,
    totalPagesFromData,
    filterModal,
    setFilterModal,
    selectedFilters,
    setSelectedFilters,
    filterTileSidebar,
    setFilterTileSidebar,
    categoryNames,
    setCategoryNames,
    categoryImage,
    ConfigData,
  };
};
